import { useEffect, useRef, useState } from "react";

const LOADING_TIMEOUT = 15000;

export const useShowLoadingMessage = (isLoadingData: boolean) => {
    const [showLoadingMessage, setShowLoadingMessage] = useState(false);

    const timeoutId = useRef<ReturnType<typeof setTimeout> | null>(null);

    useEffect(() => {
        if (isLoadingData) {
            timeoutId.current = setTimeout(() => {
                setShowLoadingMessage(true);
            }, LOADING_TIMEOUT);
        } else {
            if (timeoutId.current) {
                clearTimeout(timeoutId.current);
            }
            setShowLoadingMessage(false);
        }
        return () => {
            if (timeoutId.current) {
                clearTimeout(timeoutId.current);
            }
        };
    }, [isLoadingData]);

    return { showLoadingMessage };
};
